// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3LLNg","left":"styles_left__3pnPo"};